import ajax from '@/lib/ajax'
import cookie from 'js-cookie'
import AuthenticateModel from '@/store/models/authenticate-model'
import moment from 'moment'
import Vue from 'vue'

import LoginResult from '@/store/models/login-result'
import OU from '@/store/entities/ou'

const openidKey = 'openid'
const returnUrl = 'return-url'

class App {
	auth: Auth = new Auth()

	userInfoStoreKey: string = 'userInfo'
	warehouseStoreKey: string = 'current-warehouse'
	// 所有仓库信息，获取时请调用getAllOus方法
	ous: Array<OU> = []

	public logout() {
		localStorage.clear()
		sessionStorage.clear()
		// util.removeToken()
	}
	// 设置当前登录人的信息
	public setUserInfo(info: string) {
		localStorage.setItem(this.userInfoStoreKey, info)
	}
	// 获取当前登录人的信息
	public getUserInfo(): LoginResult | null {
		let str = localStorage.getItem(this.userInfoStoreKey)
		if (!str) return null
		return JSON.parse(str)
	}
	getOpenId() {
		return localStorage.getItem(openidKey)
	}
	setOpenId(openid: string) {
		localStorage.setItem(openidKey, openid)
	}
	getReturnUrl() {
		return localStorage.getItem(returnUrl)
	}
	setReturnUrl(url: string) {
		localStorage.setItem(returnUrl, url)
	}
	isProduction() {
		return process.env.NODE_ENV === 'production'
	}
}
const vue = new Vue()
class Auth {
	async authenticate(model: AuthenticateModel) {
		await ajax.post('/login', model).then(async rep => {
			cookie.set('access_token', rep.data.result)
			// console.log('login', rep.data)
		})

	}

	public async authenticateByOpenId(model: AuthenticateModel) {
		let user: any
		await ajax.post('/login', model).then(rep => {
			user = rep.data
		})
		return user
	}
	/**
	 * 退出登录
	 */
	logout() {
		sessionStorage.clear()
		localStorage.clear()
		cookie.remove('access_token')
	}
	// public setCurrentPermission(data: string) {
	// 	localStorage.setItem('permissions', data)
	// }
	// public getAllPermossions() : Array<string> {
	// 	let permissions = localStorage.getItem('permissions')
	// 	if(!permissions) return []
	// 	else return JSON.parse(permissions)
	// }
	public hasPermission(permission: string) {
		let permissions: Array<string> = vue.$store.state.permission.currentUserPermissionKeys
		return permissions.findIndex(t => t.toLowerCase() === permission.toLowerCase()) > -1
	}
	public hasAnyOfPermissions(...argus: string[]) {
		if (!argus || argus.length === 0)
			return false
		let permissions: Array<string> = vue.$store.state.permission.currentUserPermissionKeys
		return permissions.some(t => argus.indexOf(t) > 0)
	}
	public hasAllOfPermissions(...argus: string[]) {
		if (!argus || argus.length === 0)
			return false
		let permissions: Array<string> = vue.$store.state.permission.currentUserPermissionKeys
		return !permissions.some(t => argus.indexOf(t) < 0)
	}
}

const app = new App()
export default app

interface ApplicationConfigurationDto {
	localization: ApplicationLocalizationConfigurationDto
	auth: ApplicationAuthConfigurationDto
	setting: ApplicationSettingConfigurationDto
	currentUser: CurrentUserDto
	features: ApplicationFeatureConfigurationDto
}
interface ApplicationLocalizationConfigurationDto {
	values: any
	languages: any
	currentCulture: any
}
interface ApplicationAuthConfigurationDto {
	policies: any
	grantedPolicies: any
}
interface ApplicationSettingConfigurationDto {
	values: any
}
interface CurrentUserDto {
	isAuthenticated: boolean
	id: string
	tenantId: string
	userName: string
}
interface ApplicationFeatureConfigurationDto {
	values: any
}
